import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddItemToListRequestType } from '@app/modules/tf-shared-list/models/types/add-item-to-list-request.type';
import { AddItemToListResponseType } from '@app/modules/tf-shared-list/models/types/add-item-to-list-response.type';
import { SharedListOpCodeEnum } from '@app/modules/tf-shared-list/models/types/enums/shared-list-opcode.enum';
import { SaveToListType } from '@app/modules/tf-shared-list/models/types/save-to-list.type';
import { SharedListType } from '@app/modules/tf-shared-list/models/types/shared-list.type';
import { TfErrorModel } from '@app/models/tf-error.model';
import { TfUserDataService } from '@app/modules/tf-user-data';
import { catchError, Observable, of, switchMap, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { AddToListError } from '../models/types/add-to-list-error';
import { GetShareListResponseType } from '../models/types/get-share-list-response.type';

@Injectable()
export class TfSharedListService {

    userName: string = 'cmgtuser';
    userPassword: string = 'cmgtuserqa@qa2.com';
    sharedListUrl: string = '/shared-list/getLists';
    saveItemToListURL: string = '/shared-list/addItemToList';

    constructor(
        private httpClient: HttpClient,
        private userDataService: TfUserDataService
    ) {
    }

    getSharedList(): Observable<SharedListType[]> {

        return this.userDataService.getUserDetails().pipe(
            switchMap((user) => {

                if (user.userId === null) {
                    return throwError(() => new TfErrorModel('NOT_LOGGED_IN', 'Not logged in'));
                }

                return this.httpClient.get<GetShareListResponseType>(this.sharedListUrl + '/' + user.userId, {
                    headers: this.makeHeaders(this.userName, this.userPassword)
                }).pipe(
                    switchMap((response) => {
                        return of(response.sharedLists);
                    }),
                    catchError(err => {
                        return throwError(() => new TfErrorModel('HTTP_ERROR', err.description));
                    })
                );

            })
        )

    }

    makeHeaders(userName: string, userPwd: string) {
        const authData = window.btoa(userName + ':' + userPwd);
        return new HttpHeaders().set('Authorization', `Basic ${authData}`);
    }

    addToNewSharedList(listName: string, assay: SaveToListType): Observable<AddItemToListResponseType> {

        const payload: AddItemToListRequestType = {
            'opcode': SharedListOpCodeEnum.CREATE_LIST_AND_ADD_ITEM,
            'listName': listName,
            'lineItems': [assay]
        }


        return this.httpClient.post<AddItemToListResponseType>(this.saveItemToListURL, payload, {headers: null}).pipe(
            map((response) => {
                if (this.isAddToListError(response)) {
                    throw response;
                }
                return response;
            }),
            catchError(err => {
                return throwError(() => new TfErrorModel('HTTP_ERROR', err.description));
            })
        );

    }

    addToExistingSharedList(list: SharedListType, assay: SaveToListType): Observable<any> {

        const payload = {
            'opcode': SharedListOpCodeEnum.ADD_TO_LIST_EXISTING_LIST,
            'listId': list.listId,
            'lineItems': [assay]
        }

        return this.httpClient.post(this.saveItemToListURL, payload, {
            headers: this.makeHeaders(this.userName, this.userPassword)
        }).pipe(
            map((response) => {
                if (this.isAddToListError(response)) {
                    throw response;
                }
                return response;
            }),
            catchError(err => {
                return throwError(() => new TfErrorModel('HTTP_ERROR', err.description));
            })
        );

    }

    isAddToListError(response: any): response is AddToListError {
        return 'code' in response && 'message' in response && 'processingTime' in response && 'translationCode' in response;
    }

}
